import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';
import { map, toLower } from 'lodash';
import moment from 'moment';

import { HHInput, HHTextArea, HHSingleSelect, HHDatePicker } from './fields';
import { FORM_NAME } from '../forms/formConstant';
import { TICKET_STATUS } from '../cms/constant';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) => Yup.object().shape({
    type: Yup.string().max(64).required(translate('form.error.mixed.required')),
    description: Yup.string().max(128, translate('form.error.string.max')),
    status: Yup.string().required(translate('form.error.mixed.required')),
    price: Yup
      .number()
      .positive(translate('form.error.number.positive'))
      .test(
        'stripePrice',
        translate('form.error.number.stripePrice'),
        (value) => !(value > 0 && value < 0.5)
      ),
    quantities: Yup.number().positive(translate('form.error.number.positive'))
  }),
  mapPropsToValues: (props) => (props.initialValues),
  handleSubmit: (values, { props }) => {
    props.handleSubmit(values);
  },
  displayName: FORM_NAME.CMS_TICKET_FORM_CREATE
});

const TicketForm = (props) => {
  const {
    handleCancel, handleSubmit, isSubmitting, isEditing, timezone, activeLanguage, translate
  } = props;

  return (
    <Form
      onSubmit={handleSubmit}
      className='cms-tickets_form cms-tickets_table_item_flexibleArea'
    >
      <div className='cms-tickets_table_item_flexibleArea_name'>
        <Form.Field>
          <label htmlFor='type'>{translate('ticket.name.required')}</label>
          <Field
            name='type'
            component={HHInput}
            otherProps={{
              id: 'type',
              type: 'text',
              maxLength: 64
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='description'>{translate('ticket.description')}</label>
          <Field
            name='description'
            component={HHTextArea}
            otherProps={{
              id: 'description',
              maxLength: 128
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='status'>{translate('status')}</label>
          <Field
            name='status'
            component={HHSingleSelect}
            otherProps={{
              id: 'form-maxTeamMembers',
              simpleValue: true,
              searchable: false,
              clearable: false,
              options: map(
                TICKET_STATUS,
                ts => ({ value: ts, label: translate(`common.${toLower(ts)}`) })
              ),
              placeholder: translate('status')
            }}
          />
        </Form.Field>
      </div>

      <div className='cms-tickets_table_item_flexibleArea_price'>
        <Form.Field>
          <label htmlFor='price'>{translate('ticket.price.required')}</label>
          <Field
            name='price'
            component={HHInput}
            otherProps={{
              id: 'price',
              type: 'number',
              step: '0.01',
              min: 0
            }}
          />
        </Form.Field>
      </div>

      <div className='cms-tickets_table_item_flexibleArea_quantities'>
        <Form.Field>
          <label htmlFor='quantities'>{translate('ticket.quantities.required')}</label>
          <Field
            name='quantities'
            component={HHInput}
            otherProps={{
              type: 'number',
              id: 'quantities',
              min: 0
            }}
          />
        </Form.Field>
      </div>

      <div className='cms-tickets_table_item_flexibleArea_date'>
        <Form.Field>
          <label htmlFor='form-start'>{translate('start.date.and.time')}</label>
          <Field
            name='start'
            component={HHDatePicker}
            otherProps={{
              id: 'form-start',
              className: 'cms-tickets_table_item_flexibleArea_date_startInput',
              icon: 'phone',
              iconPosition: 'left',
              locale: activeLanguage.code,
              timezone,
              minDate: moment(),
              placeholderText: translate('select start date')
            }}
          />
        </Form.Field>

        <Form.Field>
          <label htmlFor='form-end'>{translate('end.date.and.time')}</label>
          <Field
            name='end'
            component={HHDatePicker}
            otherProps={{
              id: 'form-end',
              className: 'cms-tickets_table_item_flexibleArea_date_endInput',
              icon: 'phone',
              iconPosition: 'left',
              locale: activeLanguage.code,
              timezone,
              minDate: moment(),
              placeholderText: translate('select end date')
            }}
          />
        </Form.Field>

        <div className='cms-tickets_table_item_flexibleArea_date_btnGroup'>
          {handleCancel && (
            <Button basic type='button' onClick={handleCancel}>
              {translate('cancel')}
            </Button>
          )}
          <Button
            primary
            disabled={isSubmitting}
            loading={isSubmitting}
            type='submit'
          >
            {isEditing ? translate('save') : translate('create')}
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default compose(
  withLocalize,
  formikEnhancer
)(TicketForm);



// WEBPACK FOOTER //
// ./src/components/forms/ticketForm.js